interface ErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
    message: string | null;
}

export function ErrorModal({ isOpen, onClose, message }: ErrorModalProps) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="w-full max-w-md rounded-xl bg-surface-700 border border-border p-6 shadow-xl">
                <h3 className="mb-4 text-lg font-medium text-health-400">Error</h3>
                <p className="mb-6 text-text-secondary">{message}</p>
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="btn-secondary"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}